import * as React from 'react';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import { Typography, Menu, MenuItem, MenuList, Box } from '@mui/material';


export default function DropMenu({ model, icon }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <Box sx={{ position: 'relative' }}>
            <Box
                sx={{ cursor: 'pointer' }}
                onClick={handleClick}>
                {icon ? icon : "click here"}
            </Box>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <MenuList>
                    {model.map((m) => <MenuItem onClick={(event) => m.command()}>
                        <ListItemIcon>
                            {m.icon}
                        </ListItemIcon>
                        <ListItemText fontSize={10}>
                            <Typography>{m.label}</Typography>
                        </ListItemText>
                    </MenuItem>)}
                </MenuList>
            </Menu>
        </Box>
    );
}
